// SPM Product Page plugin
// The semi-colon before the function invocation is a safety
// net against concatenated scripts and/or other plugins
// that are not closed properly.
; (function ($, window, document, undefined) {

    // undefined is used here as the undefined global
    // variable in ECMAScript 3 and is mutable (i.e. it can
    // be changed by someone else). undefined isn't really
    // being passed in so we can ensure that its value is
    // truly undefined. In ES5, undefined can no longer be
    // modified.

    // window and document are passed through as local
    // variables rather than as globals, because this (slightly)
    // quickens the resolution process and can be more
    // efficiently minified (especially when both are
    // regularly referenced in your plugin).

    // Create the defaults once
    var pluginName = 'spmproductpage';
    var defaults = {};

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend({}, defaults, options);

        this.xhr = null;

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    Plugin.prototype.init = function () {
        this.getFiles();
    };

    Plugin.prototype.getFiles = function () {
        var $base = this;

        var $downloads = $('#downloads', $base.$element);
        if (!$downloads)
            return;

        var request = {
            FilterCategoryId: parseInt($downloads.data('filtercategory')),
            FilterTag: $downloads.data('filtertag'),
            ModifiedSince: null,
            FilterText: $downloads.data('filtertext')
        };

        var $fileswrapper = $('.files-wrapper', $downloads);

        $base.xhr = $.ajax({
            type: 'POST',
            data: request,
            url: '/partials/downloads/files',
            beforeSend: function () {
                if ($base.xhr != null) {
                    $base.xhr.abort();
                }

                $fileswrapper.html('<div class="d-flex justify-content-center"><i class="fas fa-circle-notch fa-spin"></i></div>');
            },
            success: function (data) {
                $fileswrapper.html(data);
            }
        });
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new Plugin(this, options));
            }
        });
    };
})(jQuery, window, document);